import { render, staticRenderFns } from "./PortfolioHoldingsArea.vue?vue&type=template&id=8ca0e22c&scoped=true&"
import script from "./PortfolioHoldingsArea.vue?vue&type=script&lang=js&"
export * from "./PortfolioHoldingsArea.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHoldingsArea.vue?vue&type=style&index=0&id=8ca0e22c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca0e22c",
  null
  
)

export default component.exports